import React from 'react';
import { materials, type Material } from '../data/materials';
function MaterialRow({
  material,
  reverse
}: {
  material: Material;
  reverse: boolean;
}) {
  const featured = material.accent === 'coral';
  return <div className={`flex flex-col ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-6 rounded-3xl p-6 ${featured ? 'bg-[#FDF8EF] border-2 border-[#F5CE3E] shadow-lg' : 'bg-gray-50 border border-gray-200'}`} data-id="element-78" data-mp="w6967y9tryjj">
      <div className="w-full md:w-1/2 flex justify-center" data-id="element-79" data-mp="16586asgiylux">
        <img src={material.image} alt={`Material ${material.number}: ${material.title}`} className="w-[320px] max-w-full h-auto object-contain drop-shadow-xl rounded-lg" data-id="element-80" data-mp="1a6a5j9afyxww" />
      </div>

      <div className="w-full md:w-1/2" data-id="element-81" data-mp="1jwlkrrzkstj3">
        <h3 className="text-xl md:text-2xl font-black mb-2 text-[#14356B] leading-tight" data-id="element-82" data-mp="1jwd9g4j3pwa0">
          {material.title}
        </h3>
        <p className="text-base font-bold text-[#157C8B] mb-2" data-id="element-83" data-mp="1ou4zsu43lac3">
          {material.pages}
        </p>
        <p className="text-lg text-gray-700 mb-4" data-id="element-84" data-mp="1tsolquioym4g">{material.tagline}</p>
        <p className="text-sm font-bold text-gray-500 uppercase tracking-wide mb-2" data-id="element-85" data-mp="19el38888b3zg">
          {material.intro}
        </p>
        <ul className="space-y-1.5 text-base text-gray-800" data-id="element-86" data-mp="14g9vc31hv3jv">
          {material.topics.map(topic => <li key={topic} className="flex items-start" data-id="element-87" data-mp="zgx0ow4dss6q">
              <span className="text-[#157C8B] mr-2 font-bold" data-id="element-88" data-mp="veaebaqhbzgx">✔</span>
              {topic}
            </li>)}
        </ul>
        <p className="text-base font-bold text-[#14356B] mt-4" data-id="element-89" data-mp="1s2ztgtaq2dz7">
          {material.closing}
        </p>
      </div>
    </div>;
}
export function MaterialsSection() {
  return <section className="py-10 px-4 bg-white" data-id="element-90" data-mp="1icwxck8b0jwn">
      <div className="max-w-5xl mx-auto" data-id="element-91" data-mp="1iblpa87tspzq">
        <div className="text-center mb-8" data-id="element-92" data-mp="1ecwg6rttlulw">
          <h2 className="text-[20px] md:text-2xl font-black mb-3 text-[#14356B]" data-id="element-93" data-mp="1ebuultf6hppx">
            ¿QUÉ VAS A ENCONTRAR?
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-94" data-mp="263alhznrpyly">
            Tres materiales que se complementan. Elegís la etapa que estás
            acompañando y la llevás al encuentro.
          </p>
        </div>

        <div className="space-y-8" data-id="element-95" data-mp="95d2ue1ywy33">
          {materials.map((material, index) => <MaterialRow key={material.number} material={material} reverse={index % 2 === 1} data-id="element-96" data-mp="96o4o8burvrk" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}